import React, { useContext } from 'react'
import classNames from 'classnames'
import { marked } from 'marked'
import {
  PageContext,
  PageContextProps
} from '@toasttab/shared/src/hooks/usePageContext'
import { TypographyProps, TypographyVariation } from './Typography.d'

const Typography = ({
  allowHtml = true,
  ariaLabel,
  as = 'div',
  children: initialChildren,
  classes,
  heapInteraction,
  id,
  useSmall,
  variation = 'default'
}: TypographyProps) => {
  const Element = as
  const pageContext = useContext(PageContext)
  const children = Array.isArray(initialChildren)
    ? initialChildren.filter((c: any) => !!c)
    : initialChildren

  const typographyClasses = classNames(
    classes,
    getTypographyClasses(variation, useSmall, pageContext)
  )

  return (
    <>
      {allowHtml ? (
        <Element
          className={typographyClasses}
          data-interaction={heapInteraction}
          data-testid='mds-typography'
          id={id}
          dangerouslySetInnerHTML={{
            __html: marked.parseInline((children || '') as string)
          }}
        />
      ) : (
        <Element
          className={typographyClasses}
          data-interaction={heapInteraction}
          data-testid='mds-typography'
          id={id}
        >
          {children}
        </Element>
      )}
      {ariaLabel ? <span className='sr-only'>{ariaLabel}</span> : null}
    </>
  )
}

export default Typography

export const getTypographyClasses = (
  variation: TypographyVariation,
  useSmall: boolean,
  pageContext?: PageContextProps
) => {
  return classNames({
    'lg:type-display lg:font-normal': variation === 'display' && !useSmall,
    'lg:type-headline-1': variation === 'h1' && !useSmall,
    'lg:type-headline-2 ': variation === 'h2' && !useSmall,
    'lg:type-headline-3 lg:font-medium': variation === 'h3' && !useSmall,
    'lg:type-headline-4': variation === 'h4' && !useSmall,
    'lg:type-headline-5 ': variation === 'h5' && !useSmall,
    'type-default font-normal': variation === 'default',
    'type-overline font-normal': variation === 'overline',
    'type-caption font-normal': variation === 'caption',
    'font-normal text-[14px]':
      variation === 'statement' && pageContext?.styleContext !== 'request-demo',
    'font-normal text-[12px] first:text-[16px]':
      variation === 'statement' && pageContext?.styleContext === 'request-demo',
    'type-footnote font-normal': variation === 'footnote',
    'type-display-sm font-medium': variation === 'display',
    'type-headline-2 font-medium': variation === 'h1',
    'type-headline-3 font-medium': variation === 'h2',
    'type-headline-4 font-normal': variation === 'h3',
    'type-headline-5 font-normal': variation === 'h4',
    'type-default font-semibold': variation === 'h5'
  })
}
